import React from 'react';
import PropTypes from 'prop-types';
import CommonAppSetup from '../../../common/common-app-setup/CommonAppSetup';
import Components from '../../../common/Components';
import joinClassNames from "../../../common/JoinClassNames";
import handleEvent from "../../../common/events/HandleEvent";
import AjaxSpinner from "../../ajax-spinner/AjaxSpinner";
import { uniqueId } from 'lodash';

/*
	shows a section header that can be clicked to collapse/expand it
	uses React "children" to show the contents of the section
 */

const propTypes = {
	// classname(s) to add to the rendered DOM element
	className: PropTypes.string,

	// the section was clicked, caller can now toggle showing it or not
	clickSection: PropTypes.func.isRequired,

	// node to show when section opened/closed
	// since the parent controls the "expanded" property it also controls which node to show
	collapsibleIndicator: PropTypes.node,

	// is this section expanded? doesn't show children if not expanded
	expanded: PropTypes.bool.isRequired,

	// can tell section that it is being ajaxed for data and will show spinner in this section
	isAjaxing: PropTypes.bool,

	// When the component mounts should the input be given focus.
	setInitialFocus: PropTypes.bool,

	// title to show in section header, as well as identifies this section
	title: PropTypes.string.isRequired,

	// a React ref that will be hooked to the title of the collapsible section
	titleRef: PropTypes.object,
};

const defaultProps = {
	className: undefined,
	collapsibleIndicator: null,
	isAjaxing: false,
	setInitialFocus: false,
};

export default class CollapsibleSection extends React.Component {
	constructor(props) {
		super(props);

		this.linkRef = props.titleRef || React.createRef();
		this.ariaControls = uniqueId('section_');
		this.ariaButtonId = uniqueId('button_');
	}

	componentDidMount() {
		if (this.props.setInitialFocus) {
			this.linkRef.current.focus();
		}
	}

	render() {
		let content = undefined;
		if (this.props.expanded) {
			if (this.props.isAjaxing) {
				content = (
					<div className="collapsible-section__more-records" role="region" aria-labelledby={this.ariaButtonId} id={this.ariaControls}>
						<AjaxSpinner size={60}/>
					</div>
				);
			} else if (this.props.children) {
				content = <div className={joinClassNames('collapsible-section__content', CommonAppSetup.getClassName(Components.COLLAPSIBLE_SECTION, 'sectionContent'))} role="region" aria-labelledby={this.ariaButtonId} id={this.ariaControls}>{this.props.children}</div>;
			}
		}

		return (
			<div className={joinClassNames('collapsible-section', this.props.className)}>
				<header className={joinClassNames(
					'collapsible-section__header',
					this.props.expanded ? 'open' : 'closed',
					CommonAppSetup.getClassName(Components.COLLAPSIBLE_SECTION, 'sectionHeader')
				)}>
					<span
						className="collapsible-section__title"
						onClick={handleEvent(() => this.props.clickSection(this.props.title))}
					>
						<button className="collapsible-section__title-text"
								aria-expanded={this.props.expanded}
								aria-controls={this.ariaControls}
								id={this.ariaButtonId}
								ref={this.linkRef}>
							{this.props.title}
						</button>
						{
							this.props.collapsibleIndicator ?
								<div className={joinClassNames("collapsible-section__title-indicator after", this.props.expanded ? 'open' : 'closed')}>{this.props.collapsibleIndicator}</div>
								: undefined
						}
					</span>
				</header>
				{content}
			</div>
		);
	}
}

CollapsibleSection.defaultProps = defaultProps;
CollapsibleSection.propTypes =  propTypes;
